import React, { useState } from "react";
import ButtonSpinner from "../../ButtonSpinner";
import API_URL from '../../../utils/api';
import "../../Dashboard/View/Dashboard.css";
export default function IntelliMeStartModal({ user, onSuccess, onClose }) {
  const [sessionName, setSessionName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const handleStart = async (e) => {
    e.preventDefault();
    if (!sessionName.trim()) {
      setError("Please enter a session name");
      return;
    }
    setLoading(true);
    setError("");
    try {
      // Create a new session
      const response = await fetch(`${API_URL}/api/sessions`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          name: sessionName,
          host: user.name || user.displayName,
          hostId: user.id || user.uid,
          members: [{ 
            name: user.name || user.displayName, 
            user_id: user.id || user.uid 
          }]
        })
      });
      const data = await response.json();
      if (response.ok && data.id) {
        // Navigate to lobby with session ID
        onSuccess(data.id);
      } else {
        setError(data.message || 'Failed to create session');
      }
    } catch (err) {
      setError('Failed to create session. Please try again.');
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="dashboard-section dashboard-create-session">
      <h3>Start IntelliMe Session</h3>
      <p style={{ color: '#666', marginBottom: '24px', fontSize: '0.95rem' }}>
        Create a session and invite up to 6 participants for meaningful conversations.
      </p>
      <form onSubmit={handleStart}>
        <input
          type="text"
          placeholder="Session Name (e.g., Weekend Chat)"
          value={sessionName}
          onChange={e => setSessionName(e.target.value)}
          className="dashboard-input"
          autoFocus
        />
        <button
          className="dashboard-btn"
          type="submit"
          disabled={loading}
        >
          {loading ? <ButtonSpinner /> : "Create & Go to Lobby"}
        </button>
      </form>
      {error && <div className="dashboard-error">{error}</div>}
      <button className="dashboard-modal-close" onClick={onClose}>&times;</button>
    </div>
  );
}
